// eslint-disable-next-line import/prefer-default-export
export const transformRONS = obj => {
    // eslint-disable-next-line no-restricted-syntax
    for (const k of Object.keys(obj)) {
        if (typeof obj[k] === 'string') {
            // eslint-disable-next-line no-param-reassign
            obj[k] = obj[k].toUpperCase();
        }
        else if(Array.isArray(obj[k])) {
            const arrayValueCapital = [];
            obj[k].forEach(data => {
                arrayValueCapital.push(data.toUpperCase());
            });
            // eslint-disable-next-line no-param-reassign
            obj[k] = arrayValueCapital;
        }
    }
    return obj;
};